import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { CommonModule } from '@angular/common';
import { QRDialogComponent } from './qr-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material/material.module';

@NgModule({
  declarations: [QRDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class QRDialogModule {}
